/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userAmazonCatalogue.internal

import features.userAmazonCatalogue.models.UserRewardsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserAmazonCatalogueRequest : NetworkRequest() {

    suspend fun getUserAmazonCatalogue(
        overrideHeaders: Map<String, String>? = null,
        pageNumber: Int,
        perPage: Int,
        keywords: String?,
        filters: String?
    ): IOResult<UserRewardsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserAmazonCatalogueEndpoint.replaceInPath(
                    PathParameter("pageNumber", pageNumber),
                    PathParameter("perPage", perPage),
                    PathParameter("keywords", keywords),
                    PathParameter("filters", filters),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
